import React from "react"

const Footer = () => (
  <footer>
    <span>&copy; 2019 - United States Bowling Congress. All rights reserved.</span>
    <span style={{ marginLeft:'20%' }}>Build v1.25303.9
    </span>
  </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/layout/Footer.js